import { useCallback,  } from 'react';
import Box from '@mui/material/Box';
import Text from '@components/v2/ui-elements/Text';
import Button from '@components/v2/ui-elements/Button';


function ErrorBoundaryMessage() {
//   const [showDetails, setShowDetails] = useState(false);
  
  const onReloadClick = useCallback(() => {
    window.location.reload();
  }, []);
  
//   const onToggleDetails = useCallback(() => {
//     setShowDetails(prev => !prev);
//   }, []);

  return (
    <Box height="90vh" flex={1} display="flex" alignItems="center" justifyContent="center">
      <Box
        maxWidth="480px"
        border="1px solid rgba(0, 0, 0, 0.1)"
        padding="24px"
        borderRadius="8px"
        style={{ backgroundColor: '#fff' }}>
        <Text element="h2" fontWeight="bold" className="fs__7">
          Something went wrong.
        </Text>

        <Text element="p" className="fs__3">
          There was an unexpected error on the page. Please reload and try again.
        </Text>
        
        

        <Box display="flex" gap={2} marginTop={3}>
          <Button onClick={onReloadClick}>Reload</Button>
          {/* <Button variant="outlined" onClick={onToggleDetails}>
            {showDetails ? 'Hide Details' : 'Show Details'}
          </Button> */}
        </Box>
        
        {/* {showDetails && (
          <Box marginTop={3} padding={2} bgcolor="#f5f5f5" borderRadius={1}>
            <Text element="p" className="fs__3" style={{ marginBottom: '8px' }}>
              <strong>URL:</strong> {window.location.href}
            </Text>
            <Text element="p" className="fs__3" style={{ marginBottom: '8px' }}>
              <strong>Time:</strong> {new Date().toLocaleString()}
            </Text>
            <Text element="p" className="fs__3">
              <strong>User Agent:</strong> {navigator.userAgent}
            </Text>
          </Box>
        )} */}
      </Box>
    </Box>
  );
}

export default ErrorBoundaryMessage; 